


























import { Prop, Component, Vue } from "vue-property-decorator";
import SignIn from "../components/Login/SignIn.vue";
import SignUp from "../components/Login/SignUp.vue";
import { createUserWithEmailAndPassowrd } from '../services/firebaseAuths';
//import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src

@Component({
  components: {
    SignIn,
    SignUp
  },
})
export default class Home extends Vue {
  public step = 1;
   

  public updateStep(comeStep: number){
    this.step = comeStep;
  } 
  
}
